<div #fullscreenContainer class="web-browser" [class.is-fullscreen]="isFullscreen">
  <div class="row position-relative pb-2">
    <spinner class="spinner w-100"></spinner>
  </div>
  <div class="position-relative h-100 book-area">
    <div #bookContainer id="bookContainer" class="book-container book-v2 h-100 w-100 shadow">
      <div #contentContainer id="contentContainer" class="w-100 h-100 overflow-auto"
         [innerHTML]="ebookContent"
         [ngStyle]="getZoom()"
         [ngClass]="getVariant()"
         (click)="onContentClick($event)"
      ></div>
    </div>

  </div>

  <div class="control-bar shadow mt-3">
      <div class="my-2">
        <app-icon
          (click)="moveToPreviousPage()"
          class="lg-icon"
          name="arrow-back"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.PREVIOUS_PAGE' | translate"
        ></app-icon>
      </div>
      <div class="my-2">
        <app-icon
          (click)="jumpToPageModal.show()"
          class="md-icon icon-blue"
          name="go-to-page"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.JUMP_TO_PAGE' | translate"
        ></app-icon>
      </div>
      <div class="my-2">
        <app-icon
          (click)="tocModal.show()"
          class="md-icon icon-blue"
          name="toc"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.TABLE_OF_CONTENTS' | translate"
        ></app-icon>
      </div>
      <div class="my-2 d-none d-md-block position-relative">
        <app-icon
          (click)="showBookSizeSettings()"
          class="md-icon"
          name="font-size"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.TEXT_SIZE' | translate"
        ></app-icon>
        <ng-container *ngIf="isBookSizeSettingsShown" class="position-absolute ">
            <div class="font-size-menu rounded-pill shadow px-3 py-2 d-flex flex-row justify-content-between">
            <app-icon
              class="me-3"
              name="text-decrease"
              (click)="changeTextSize(-1)"
            ></app-icon>
            <app-icon
              name="text-increase"
              (click)="changeTextSize(1)"
            ></app-icon>
        </div>
        </ng-container>
      </div>
      <div class="my-2">
        <app-icon
          (click)="toggleFullscreen()"
          class="md-icon"
          name="fullscreen"
          data-bs-toggle="tooltip" data-bs-placement="top"
          [title]="(isFullscreen ? 'EBOOKS.EXIT_FULLSCREEN' : 'EBOOKS.FULLSCREEN') | translate"
        ></app-icon>
      </div>
      <div class="my-2">
        <app-icon
          (click)="moveToNextPage()"
          class="lg-icon"
          id="buttonNext"
          name="arrow-next"
          data-bs-toggle="tooltip" data-bs-placement="top" [title]="'EBOOKS.NEXT_PAGE' | translate"
        ></app-icon>
      </div>
  </div>

  <!-- Jump to a page (pages only; anchors are reached via next/prev or the table of contents). -->
  <app-modal #jumpToPageModal>
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title">{{ "EBOOKS.JUMP_TO_PAGE" | translate }} <label>[{{firstPage}} - {{lastPage}}]</label></h5>
        <button type="button" class="btn-close" (click)="jumpToPageModal.hide()" aria-label="Close"></button>
      </div>
      <form #form="ngForm" (submit)="jumpToPage()">
        <div class="modal-body">

          <input
            [(ngModel)]="pageSelection"
            [ngModelOptions]="{standalone: true}"
            class="form-control bg-white text-black my-2"
            type="number"
            required
            #pageSelectionInput="ngModel"
            [min]="firstPage"
            [max]="lastPage"
            />
          <div class="text-danger" *ngIf="pageSelectionInput.invalid && pageSelectionInput.touched">
            {{ "EBOOKS.RANGE_ERROR" | translate}} {{firstPage}} - {{lastPage}}.
          </div>
        </div>
        <div class="modal-footer border-0">
          <button class="btn btn-primary rounded-pill" [disabled]="pageSelectionInput.invalid" (click)="jumpToPage()">
            {{ "EBOOKS.GO_TO_PAGE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </app-modal>

  <!-- Table of contents built from the manifest `contents`; clicking an entry jumps to its first
       anchor / page. -->
  <app-modal #tocModal>
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title">{{ "EBOOKS.TABLE_OF_CONTENTS" | translate }}</h5>
        <button type="button" class="btn-close" (click)="tocModal.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="accordion" id="tocAccordion">
          <div class="accordion-item" *ngFor="let group of tocGroups; let i = index">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button"
                      data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#tocCollapse' + i"
                      aria-expanded="false"
                      [attr.aria-controls]="'tocCollapse' + i">
                {{ group.label }}
              </button>
            </h2>
            <div [id]="'tocCollapse' + i" class="accordion-collapse collapse" data-bs-parent="#tocAccordion">
              <div class="accordion-body">
                <ul class="list-unstyled mb-0">
                  <li *ngFor="let item of group.entries; let last = last"
                      class="cursor-pointer p-1"
                      [class.border-bottom]="!last"
                      (click)="goToEntry(item.key)">
                    {{ item.entry.title }}
                    <span class="xsmall text-muted" *ngIf="item.entry.pages"> ({{ pageRange(item.entry) }})</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-modal>

  <app-modal #videoModal size="lg">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title">{{ 'EBOOKS.VIDEO.TITLE' | translate }}</h5>
        <button type="button" class="btn-close" (click)="videoModal.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <video *ngIf="selectedVideoSrc" [src]="selectedVideoSrc" class="w-100" controls autoplay playsinline></video>
      </div>
    </div>
  </app-modal>

  <app-modal #quizModal size="lg">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title">{{ 'EBOOKS.QUIZ.TITLE' | translate }}</h5>
        <button type="button" class="btn-close" (click)="quizModal.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <app-quiz [quiz]="selectedQuiz" (done)="quizModal.hide()"></app-quiz>
      </div>
    </div>
  </app-modal>

  <app-modal #chartModal size="xl">
    <div class="modal-content chart-modal">
      <div class="modal-header border-0">
        <h5 class="modal-title">{{ selectedChartTitle }}</h5>
        <button type="button" class="btn-close" (click)="chartModal.hide()" aria-label="Close"></button>
      </div>
      <div class="modal-body chart-modal-content">
        <spinner class="w-100"></spinner>
        <div
          *ngIf="selectedChartImages.length > 0"
          class="d-grid"
          [class.chart-image-gallery-two-up]="selectedChartImages.length === 2"
        >
          <img
            *ngFor="let image of selectedChartImages"
            [src]="image.url"
            [alt]="image.alt"
          />
        </div>
      </div>
    </div>
  </app-modal>
</div>
